var map = {
	"./bee/themes/dark/logo-navigation.svg": [
		4118,
		118
	],
	"./bee/themes/light/logo-navigation.svg": [
		8054,
		54
	],
	"./hornet/themes/dark/logo-navigation.svg": [
		6330,
		330
	],
	"./hornet/themes/light/logo-navigation.svg": [
		583,
		583
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1361;
module.exports = webpackAsyncContext;